import { render, staticRenderFns } from "./CabinetBedColor.vue?vue&type=template&id=1014a386&scoped=true"
import script from "./CabinetBedColor.vue?vue&type=script&lang=js"
export * from "./CabinetBedColor.vue?vue&type=script&lang=js"
import style0 from "./CabinetBedColor.vue?vue&type=style&index=0&id=1014a386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1014a386",
  null
  
)

export default component.exports